export const SMALL_BUST = 'small busted';
export const PROPORTIONAL = 'in proportion';
export const SMALL_HIPS = 'small hips';
